import { ReferenceConfig } from "@/plugins/extensions/Reference"
import { ReferenceType } from "@/plugins/extensions/ReferenceType"

import UserList from "./User/UserList.vue"

export default {
  char: ReferenceConfig[ReferenceType.PREVIOUS_TASK_OWNER].char,
  items: () => ({
    list: [],
    type: ReferenceType.PREVIOUS_TASK_OWNER,
    component: UserList
  })
}
